import api from '../../utils/api'

import { useEffect, useState } from 'react'





/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormProduct from './Form/FormProduct'

function EditProduct({id , btCancelAction, handleOnSuccess}){
    const [product, setProduct] = useState({})
    const [grid, setGrid] = useState([])
    const [token] = useState(localStorage.getItem('token') || '')
    /* const {id} = useParams() */
    
    const {setFlashMessage} = useFlashMessage()
    

    useEffect(() => {

        api.get(`/product/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
            
        }).then((response) => {
            
            setGrid(response.data.product.sizeGrid.grid)
            setProduct(response.data.product)
        })
    }, [token, id])
    console.log("grid")
    console.log(grid)

    async function updateProduct(product) {
        let msgType = 'success'
        
        
        const data = await api.patch(`product/update/${product._id}`, product, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {
            
            return response.data
        }).catch((err) => {
            
            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()
            
            }

    }


    return (
        product.description && (
            <FormProduct title="Editar Produto" handleSubmit={updateProduct} btnText="Salvar" btCancelAction={btCancelAction} productData={product} additiveData={product.additive} aviamentosData={product.aviamentos} additionalSizeData={product.additionalSize} commissionData={product.commissions} gridData={grid} />
        )
    )
}

export default EditProduct